import { lazy } from "react";

// Authentication Pages
export const Login = lazy(() => import("./pages/auth/login"));
export const SignUp = lazy(() => import("./pages/auth/signUp"));
export const VeriflyEmail = lazy(() => import("./pages/auth/veriflyEmail"));
export const ForgetPassword = lazy(() => import("./pages/auth/forgetPassword"));
export const ForgetPasswordChange = lazy(() =>
  import("./pages/auth/forgetPasswordChange")
);

// Home Pages
export const Home = lazy(() => import("./pages/home"));
export const WatchList = lazy(() => import("./pages/home/watchlist"));
export const ConfirmEmail = lazy(() => import("./pages/home/confirmEmail"));

// Dashboard Pages
export const Dashboard = lazy(() => import("./pages/dashboard/dashboard"));
export const Offers = lazy(() => import("./pages/dashboard/offers"));
export const ListingOffers = lazy(() =>
  import("./pages/dashboard/listingOffers")
);
export const ListingDetails = lazy(() =>
  import("./pages/dashboard/listingdetails")
);
export const OffersDetails = lazy(() =>
  import("./pages/dashboard/offerdetails")
);
export const ListingDashboard = lazy(() => import("./pages/dashboard/listing"));
export const Transactions = lazy(() =>
  import("./pages/dashboard/transactions")
);
export const Notifications = lazy(() =>
  import("./pages/dashboard/notifications")
);
export const TransactionsEmpty = lazy(() =>
  import("./pages/dashboard/transactionsEmpty")
);
export const UpdateProfile = lazy(() =>
  import("./pages/dashboard/updateProfile")
);

// Other Pages
export const SearchPage = lazy(() => import("./pages/searchs"));
export const PropertyPage = lazy(() => import("./pages/propertyPage"));
export const PropertyPageShortlet = lazy(() =>
  import("./pages/propertyPageShortlet")
);
export const MakeOffer = lazy(() => import("./pages/makeOffer"));
export const ContactUs = lazy(() => import("./pages/contactUs"));
export const AboutUs = lazy(() => import("./pages/aboutUs"));

// Listin g Pages
export const ListingHome = lazy(() => import("./pages/listing"));
export const ListingForm1 = lazy(() => import("./pages/listing/form1"));
export const ListingForm2 = lazy(() => import("./pages/listing/form2"));
export const ListingForm3 = lazy(() => import("./pages/listing/form3"));
export const ListingForm4 = lazy(() => import("./pages/listing/form4"));
export const ListingForm5 = lazy(() => import("./pages/listing/form5"));
export const ListingSummary = lazy(() =>
  import("./pages/listing/listingSummary")
);

// Not Found Page
export const NotFound = lazy(() => import("./pages/notFound"));
